export enum SelectClinicsSortingHeadersEnum {
    id="id",
    name="name",
    address="address",
    
}
